import { ArrowRight } from '@icons';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import NewPasswordForm from './NewPasswordForm';
import { useHistory } from 'react-router-dom';

export default function AuthSection({ profileFromApi }) {
	const [isEditing, setIsEditing] = useState(false);
	const history = useHistory();
	return (
		<>
			<h2
				style={{
					textTransform: 'none',
					fontSize: '32px',
					fontWeight: 700,
					margin: '36.8px 0 56px 0',
					lineHeight: '100%',
				}}
			>
				Autenticazione
			</h2>

			<div className={`simple-box scenarita custom-simple_box`}>
				{!isEditing ? (
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div style={{ display: 'grid', gap: '8px' }}>
							<h3
								style={{
									fontSize: '18px',
									fontWeight: 700,
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								Password
							</h3>

							<p
								style={{
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								•••••••••••••••
							</p>
						</div>
						<Button
							onClick={() => {
								setIsEditing(true);
							}}
							style={{
								border: 'none',
								backgroundColor: 'transparent',
								// color: '#06797F',
								color: 'var(--np-primary-color)',

								fontWeight: 500,
								textTransform: 'none',
							}}
						>
							Modifica
							<ArrowRight style={{ marginLeft: '12px', fill: 'var(--np-primary-color)' }} />
						</Button>
					</div>
				) : (
					<NewPasswordForm profileFromApi={profileFromApi} callback={() => setIsEditing(false)} />
				)}
			</div>

			<div
				className={`simple-box scenarita custom-simple_box`}
				style={{
					minHeight: '96px',
					display: 'flex',
					alignItems: 'center',
				}}
			>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
					<div style={{ display: 'grid', gap: '8px' }}>
						<h3
							style={{
								fontSize: '18px',
								fontWeight: 700,
								lineHeight: '28px',
								marginBottom: 0,
							}}
						>
							Informativa Privacy
						</h3>
					</div>
					<Button
						onClick={() => {
							history.push('#privacy-policy');
						}}
						style={{
							border: 'none',
							backgroundColor: 'transparent',
							// color: '#06797F',
							color: 'var(--np-primary-color)',

							fontWeight: 500,
							textTransform: 'none',
						}}
					>
						Visualizza
						<ArrowRight style={{ marginLeft: '12px', fill: 'var(--np-primary-color)' }} />
					</Button>
				</div>
			</div>
		</>
	);
}
